export const galleryNavItems = [
  { id: 1, label: 'Главная', href: '/' },
  { id: 2, label: 'Документы', href: '/documents' },
  { id: 3, label: 'Галерея', href: '/gallery' },
  { id: 4, label: 'Архив новостей', href: '/archived-news' }
];